import { render, staticRenderFns } from "./other.vue?vue&type=template&id=51f91848&scoped=true"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=51f91848&prod&lang=scss&scoped=true"
import style1 from "./other.vue?vue&type=style&index=1&id=51f91848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f91848",
  null
  
)

export default component.exports